import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.476 3.148a1 1 0 0 1 1.048 0l13 8A1 1 0 0 1 29 13h-3v8h2a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h2v-8H3a1 1 0 0 1-.524-1.852zM24 13v8h-4v-8zm-6 0v8h-4v-8zm-6 0v8H8v-8zm13.467-2L16 5.174 6.533 11z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M2 25a1 1 0 1 0 0 2h28a1 1 0 1 0 0-2z" />
  </svg>
);
const SvgIconAccounting = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconAccounting);
export default Memo;
